import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuthActions } from '@xinosolutions/xs-auth-react';
import { useLearnixProduct } from '../contexts/LearnixProductContext';

export function useMemberSignIn(options = {}) {
  const navigate = useNavigate();
  const { refreshLearnixSession } = useLearnixProduct();
  const { redirectTo = '/dashboard', onError, ...rest } = options;

  const actions = useAuthActions({
    notifyError: true,
    onError,
    ...rest,
  });

  const signIn = useCallback(async () => {
    const xsResult = await actions.signIn();
    if (!xsResult) {
      return null;
    }

    try {
      await refreshLearnixSession();
      navigate(redirectTo);
      return xsResult;
    } catch (err) {
      const message =
        err instanceof Error && err.message ? err.message : 'Sign in failed';
      onError?.(message);
      return null;
    }
  }, [actions, navigate, onError, redirectTo, refreshLearnixSession]);

  const register = useCallback(async () => {
    const xsResult = await actions.register();
    if (!xsResult) {
      return null;
    }

    try {
      await refreshLearnixSession();
      navigate(redirectTo);
      return xsResult;
    } catch (err) {
      const message =
        err instanceof Error && err.message ? err.message : 'Could not create account';
      onError?.(message);
      return null;
    }
  }, [actions, navigate, onError, redirectTo, refreshLearnixSession]);

  return { ...actions, signIn, register };
}

export { useAuthActions } from '@xinosolutions/xs-auth-react';
